import { format } from "date-fns";

export const periodFormat = 'yyyy-LLL';
export const dateFormat = "MM/dd/yyy";
export const tpDateFormatForUrl = 'yyyy-MM-dd';

export function parseTimePeriodDateForUrl(date: Date): string {
  return format(date, tpDateFormatForUrl);
}

export function flattenTimePeriodDate(date: Date): Date {
  return new Date(parseTimePeriodDateForUrl(date));
}